import * as React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import RendersIcons from './RendersIcons'
import { Dialog, DialogContent, Divider, List, Box, Typography, Button } from "@mui/material";
import { postOrder } from "../api/Api";
import OrderInputText from './OrderInputText'


export default function PreOrder(props) {
  const [userName, setUserName] = React.useState("");

  const OrderPopup = () => (
    <Dialog
      open={props.isOpenCart}
      onClose={() => props.orderCreated !== null ? window.location.reload() : props.setOpenOrder(false) }
      maxWidth="sm"
      fullWidth={false}
    >
      <DialogContent
        sx={{
          minWidth: 300,
          maxWidth: 500,
          borderRadius: 2,
          p: 2,
          backgroundColor: '#fff2d7'
        }}
      >
        <Divider sx={{ mb: 2 }} />
        <List>
          {props.isOpenCart ? renderCart() : ""}
        </List>
      </DialogContent>
    </Dialog>
  );


  const renderCart = () => {
    var renderItemPopUp = []
    if (props.orderCreated == null) {
      renderItemPopUp.push(
        <OrderInputText key ={"userName"}text={userName} setText={setUserName} isError={false} label={"You Name"} />
      )
    }
    // Show the order summary
    if (props.orderCreated !== null) {
      renderItemPopUp.push(
        <React.Fragment>
          <Typography variant="h5" component="div" align="center" color="#16314c">
            <ListItemIcon>
              <RendersIcons title={"COPY"} valueToCopy={props.orderCreated.orderCode} />
            </ListItemIcon>
          </Typography>
        </React.Fragment>
      )
    }
    props.order.forEach((value, index) => {
      var tot = value.quantity * value.price
      allPrice = allPrice + tot
      if (tot !== 0) {
        renderItemPopUp.push(
          <ListItem key={index} sx={{
            '& .MuiListItemIcon-root': { color: '#000' }
          }}>
            <ListItemIcon>
              <RendersIcons title={"PIZZA"} />
            </ListItemIcon>
            <ListItemText
              primary={value.name}
              secondary={"X" + value.quantity + "  •  €" + value.price}
            />
            <ListItemIcon>
              <RendersIcons title={value.status} />
            </ListItemIcon>
          </ListItem>
        )
      }
    });

    renderItemPopUp.push(
      <div key="space" style={{ height: 60, width: '100%' }}>
      </div>
    )

    renderItemPopUp.push(
      <Button
        key={"pay"}
        variant="contained"
        disabled={props.orderCreated !== null}
        onClick={() => { createOrder(props.order) }}
        sx={{
          width: "100%",
          backgroundColor: "#22c55e",
          color: "#000",
          fontWeight: "bold",
          textTransform: "none",
          borderRadius: 2,
          py: 1.5,
          "&:hover": {
            backgroundColor: "#16a34a",
          }
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%"
          }}
        >
          <Typography variant="body1">
            {"Pay"}
          </Typography>
          <Typography variant="body1" fontWeight="bold">
            {"€" + allPrice}
          </Typography>
        </Box>
      </Button>
    )
    return renderItemPopUp;
  }

  const createOrder = (order) => {
    const orderData = {
      customerName: userName,
      pizzas: Array.from(order.values()).filter(pizza => pizza.quantity > 0)
    };
    postOrder(orderData)
      .then(result => {
        props.setOrderCreated(result);
        props.setOrder(result.pizzas)
      })
      .catch(err => console.error("Error", err));
  }

  let allPrice = 0
  return (
    <React.Fragment>
      {OrderPopup()}
    </React.Fragment>
  );
}